/**
 * Parágrafo com trechos em destaque (`**assim**`) ou em itálico de citação
 * (`_assim_`), quebrado em linhas.
 *
 * O Text do Phaser só tem um peso por objeto; aqui cada palavra vira um
 * Text e o posicionamento faz a quebra. Devolve a altura ocupada.
 */
export function criarTextoRico (scene, x, y, largura, marcado, estilo, { pesoDestaque = '600', entrelinha = 34 } = {}) {
    const palavras = [];
    // Alterna os estilos a cada marcador; o resto é texto, separado só nos espaços.
    let destaque = false, italico = false;
    marcado.split(/(\*\*|_)/).forEach((trecho) => {
        if (trecho === '**') { destaque = !destaque; return; }
        if (trecho === '_') { italico = !italico; return; }
        trecho.split(/(\s+)/).forEach((pedaco) => {
            if (pedaco === '') return;
            if (/^\s+$/.test(pedaco)) palavras.push({ espaco: true });
            else palavras.push({ texto: pedaco, destaque, italico });
        });
    });

    // Mede no contexto 2D, sem o arredondamento por objeto do Text — somado
    // em dezenas de palavras, ele mudaria onde a linha quebra.
    const pincel = document.createElement('canvas').getContext('2d');
    const fonte = (peso) => `${peso} ${estilo.fontSize} ${estilo.fontFamily}`;
    const medir = (texto, peso) => {
        pincel.font = fonte(peso);
        return pincel.measureText(texto).width;
    };
    const larguraEspaco = medir(' ', estilo.fontStyle);

    const objetos = [];
    let cx = x, cy = y, colar = false;
    palavras.forEach((palavra) => {
        if (palavra.espaco) {
            colar = false;
            return;
        }
        const peso = palavra.italico ? `italic ${pesoDestaque}` : (palavra.destaque ? pesoDestaque : estilo.fontStyle);
        const larguraPalavra = medir(palavra.texto, peso);
        const avanco = colar || cx === x ? 0 : larguraEspaco;
        if (cx + avanco + larguraPalavra > x + largura && cx > x) {
            cx = x;
            cy += entrelinha;
        } else {
            cx += avanco;
        }
        objetos.push(scene.add.text(cx, cy, palavra.texto, { ...estilo, fontStyle: peso }));
        cx += larguraPalavra;
        colar = true;       // trecho seguinte sem espaço fica colado (ex.: "X**.")
    });

    return { objetos, altura: cy - y + entrelinha };
}
